export type GenericAnalyticsData = Record<string, unknown>;

export enum AnalyticsEventType {
  pageView = "pageView",
  userIdentity = "userIdentity",
  customEvent = "customEvent",
}

export interface AnalyticsEvent {
  type: AnalyticsEventType;
  event?: string;
  userId?: string;
  [key: string]: unknown;
}

export interface KubraCommonTrackingData {
  kubra_client_id?: string;
  kubra_client_code?: string;
  kubra_client_name?: string;
}
